var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPause = function SvgPause(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    className: "fbx-has-theme-fill",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.263 1.974c-.872 0-1.579.718-1.579 1.605v12.842c0 .887.707 1.605 1.579 1.605s1.579-.718 1.579-1.605V3.579c0-.887-.707-1.605-1.579-1.605zm9.474 0c-.872 0-1.579.718-1.579 1.605v12.842c0 .887.707 1.605 1.579 1.605s1.579-.718 1.579-1.605V3.579c0-.887-.707-1.605-1.579-1.605z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fbx-overlay",
    d: "M5.263 1.974c-.872 0-1.579.718-1.579 1.605v12.842c0 .887.707 1.605 1.579 1.605s1.579-.718 1.579-1.605V3.579c0-.887-.707-1.605-1.579-1.605zm9.474 0c-.872 0-1.579.718-1.579 1.605v12.842c0 .887.707 1.605 1.579 1.605s1.579-.718 1.579-1.605V3.579c0-.887-.707-1.605-1.579-1.605z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPause, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pause.80260628.svg";
export { ForwardRef as ReactComponent };